export default __webpack_public_path__ + "c95e343672324f275019a43c9f0ffe35.png";